import React, { useEffect, useState, useRef } from 'react'
import { Header } from '../components/header/Header'
import { Footer } from '../components/footer/Footer'
import { getiBots } from '../utils/botFactoryAPI'
import './IndexHome.scss'
import './IndexPage.scss'


export function IndexHome() {
  const [iBots, setIBots] = useState<{ url: string; label: string; fullURL: string; thumb: string }[]>([])
  const [loading, setLoading] = useState(true)
  const [isPlaying, setIsPlaying] = useState(false);

  const host = window.location.origin

  const [currentVideo, setCurrentVideo] = useState<number>(0); 
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const videos = [
    "/video/to-do.mp4",
    "/video/to-do.mov",
  ];
const togglePlayPause = () => {
  if (videoRef.current) {
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  }
};

const changeVideo = (direction: "prev" | "next") => {
  console.log(`🔄 Change Video Triggered: ${direction}`);
  const newIndex =
    direction === "next"
      ? (currentVideo + 1) % videos.length
      : (currentVideo - 1 + videos.length) % videos.length;
  console.log(`➡️ New Video Index: ${newIndex}, Video: ${videos[newIndex]}`);
  setCurrentVideo(newIndex);
  setIsPlaying(false);
};

useEffect(() => {
  if (videoRef.current) {
    console.log("🎬 Setting initial video...");
    videoRef.current.src = videos[0];
    videoRef.current.load();
    videoRef.current.pause();
    setIsPlaying(false);
  }
}, []);

useEffect(() => {
  if (!videoRef.current) {
    console.error("❌ videoRef.current is null, skipping update.");
    return;
  }

  console.log(`🎥 Updating video source to: ${videos[currentVideo]}`);
  videoRef.current.src = videos[currentVideo];
  videoRef.current.load();
  videoRef.current.pause();
  setIsPlaying(false);
}, [currentVideo]);

  type User = {
    firstname: string;
    lastname: string;
    salutation?: string;
    email: string;
    username: string;
    org: {
      orgId: string;
      orgName: string;
    };
    emailVerified: boolean;
    role: string[];
    mobile: string;
    pic: string[];
    footerProfile: string | null;
  };

  const [userState, setUserState] = useState<User>({
    firstname: '',
    lastname: '',
    salutation: '', // ✅ Ensure this exists in the initial state
    email: '',
    username: '',
    org: { orgId: '', orgName: '' }, // ✅ Ensure correct structure
    emailVerified: false,
    role: ['guest'],
    mobile: '',
    pic: ['/assets/app/avatar-icon.png'],
    footerProfile: null,
  });

  const [errorMessage, setErrorMessage] = useState('')

  // Securely fetch bots
  const fetchBots = async () => {
      const token = document.cookie
      .split('; ')
      .find(row => row.startsWith('token='))
      ?.split('=')[1]; // Retrieve token value

    console.log('Token:', token); // Log token to confirm

    if (token) {
      // Use token as needed
    } else {
      console.error('Token not found in cookies');
    }

    if (token) {
      try {
        const botsData = await getiBots(token);  // Use the token from the cookie here
        if (Array.isArray(botsData)) {
          const formattedLinks = botsData.map((bot: any) => ({
            url: bot.botid,
            label: bot.name,
            thumb: bot.thumbnail,
            fullURL: `${host}/ibot?id=${bot.botid}`,
          }));
          setIBots(formattedLinks);
        }
      } catch (error) {
        console.error('Error fetching bots:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  // Token Security
  useEffect(() => {
    const handleTokenUpdate = () => {

      const token = document.cookie
        .split('; ')
        .find(row => row.startsWith('token='))
        ?.split('=')[1]; // Retrieve token value

      console.log('Token:', token); // Log token to confirm

      if (token) {
        // Use token as needed
      } else {
        console.error('Token not found in cookies');
      }

      /* Does not work on server
      const tokenTimestamp = document.cookie.replace(
        /(?:(?:^|.*;\s*)tokenTimestamp\s*\=\s*([^;]*).*$)|^.*$/,
        '$1'
      );
      */

      const tokenTimestamp =  localStorage.getItem('tokenTimestamp');

      if (token && tokenTimestamp) {
        const timeStampNumber = Number(tokenTimestamp.substring(0, 10));  
        console.log('timeStamp', timeStampNumber);
    
        const now = Date.now();
        console.log('now', now);
    
        const tokenAge = Date.now() / 1000 - timeStampNumber;  // Convert current time to seconds and calculate token age in seconds
        console.log('tokenAge', tokenAge);

        const SESSION_TIMEOUT = 15 * 60 * 1000;  // 15 minutes in milliseconds

        // If the token age is greater than the SESSION_TIMEOUT, it means the token expired
        if (tokenAge > SESSION_TIMEOUT) {
          console.log('🔄 Token expired - Redirecting to sign-in...');
          window.location.href = '/signin';  // Redirect to sign-in if the token expired
        } else {
          console.log('✅ Token valid - Fetching bots...');
          fetchBots();  // Proceed if the token is valid
        }
      } else {
        console.log('❌ No token found or timestamp missing - Redirecting to sign-in...');
        window.location.href = '/signin';  // Redirect to sign-in if no token or timestamp found
      }
    };

    handleTokenUpdate();
    window.addEventListener('tokenUpdated', handleTokenUpdate);

    return () => window.removeEventListener('tokenUpdated', handleTokenUpdate);
  }, []);
  
  return (
    <div id="root" data-component="homeIndex">
      <Header />

    <main>
    <div id="index">
      <div className="zone-container">

        {/* Zone 1 - Top Right: Contains Video */}
        <div className="zone zone-1">
        {/*  <h4 className='zone-1-title'>High Performance Team</h4>
          
          <div id='video-nav-container' className='video-nav-container'>   
            <button className="video-nav left" onClick={() => changeVideo("prev")}>
              <i className="fas fa-chevron-left"></i>
            </button>
           
            <button 
              className="video-nav play" 
              onClick={() => togglePlayPause()}>
               <i className={`fas ${isPlaying ? "fa-pause" : "fa-play"}`}></i>
            </button>
            
              <button className="video-nav right" onClick={() => changeVideo("next")}>
              <i className="fas fa-chevron-right"></i>
              </button>
           
          </div>

            <video 
                className='video-player'
                key={currentVideo} // ✅ video updates properly
                ref={(el) => {
                  videoRef.current = el; // ✅ Update videoRef dynamically
                }}
                width="100%" 
                height="100%"
                playsInline 
                controls
              >
              <source src={videos[currentVideo]} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          */}
        </div>

        {/* Zone 2 - Top Left - Contains Bots */}
        <div className="zone zone-2">
          <p>TO DO: Add Content Here</p>
          <div className="cards">
            {loading ? (
              <div
                id='status-text'
                onClick={() => {
                  // Get token from cookie
                  const token = document.cookie.replace(
                    /(?:(?:^|.*;\s*)token\s*\=\s*([^;]*).*$)|^.*$/,
                    '$1'
                  );
                  console.log('🔑 Token Retrieved from Cookie:', token);

                  if (token) {
                    console.log('✅ Token found. User is signed in. Fetching bots...');
                    fetchBots();  // Fetch bots if the token is found
                  } else {
                    console.log('❌ No token found. Redirecting to /signin...');
                    window.location.href = '/signin';  // Redirect to sign-in if token is missing
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                <br />
                Loading Agents...<br /><br />
                {/*<img src='/RobotFactory.png' id='robot-factory' />*/}
              </div>
            ) : iBots.length > 0 ? (
              iBots.map((bot, index) => (
                <div
                  key={index}
                  className="card"
                  onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    console.log("🟢 Click detected on bot card:", bot);
                    console.log("🔗 Navigating to:", bot.fullURL);

                    window.location.href = bot.fullURL; // Navigate to the bot URL
                  }}
                >
                  <img src={bot.thumb} className='bot-thumb' 
                  style={{ maxHeight: '2.5vh' }} /><br/>
                  {bot.label}
                </div>
              ))
            ) : (
              <p>No agents found - Try again</p>
            )}
          </div>
        </div>



        {/* Zone 3 - Bottom Left */}
        <div className="zone zone-3">
         {/* <span style={{ fontFamily: "'Times New Roman', Times, serif" }} className="wixui-rich-text__text"></span>
          <span style={{ fontSize: "26px" }} className="wixui-rich-text__text">
              TO DO: Add Content Here
          </span>
         <p className="font_7 wixui-rich-text__text" style={{ fontSize: "20px", lineHeight: "1.8em" }} >
            <span 
              className="wixui-rich-text__text" style={{ fontSize: "20px", color: "#000000", fontFamily: "'Times New Roman', Times, serif" }}>
              TO DO: Add Content Here
          </p>
          <h3 className="font_3 wixui-rich-text__text" style={{ fontSize: "40px" }} >
            <span className="wixui-rich-text__text" style={{ fontFamily: "Arial, 'MS PGothic', Dotum, Helvetica, sans-serif" }}>
              TO DO: Add Content Here
            </span>
          </h3>
          
          <section 
            id="comp-m4op0636" 
            className="comp-m4op0636 CohWsy wixui-column-strip"
          >
            <div 
              id="bgLayers_comp-m4op0636" 
              data-hook="bgLayers" 
              data-motion-part="BG_LAYER comp-m4op0636" 
              className="if7Vw2"
            >
              <div data-testid="colorUnderlay" className="tcElKx i1tH8h"></div>
              <div id="bgMedia_comp-m4op0636" data-motion-part="BG_MEDIA comp-m4op0636" className="wG8dni"></div>
            </div>

            <div data-testid="columns" className="V5AUxf">
         
              <div id="comp-m4op06374" className="comp-m4op06374 YzqVVZ wixui-column-strip__column">
                <div id="bgLayers_comp-m4op06374" data-hook="bgLayers" data-motion-part="BG_LAYER comp-m4op06374" className="MW5IWV">
                  <div data-testid="colorUnderlay" className="LWbAav Kv1aVt"></div>
                  <div id="bgMedia_comp-m4op06374" data-motion-part="BG_MEDIA comp-m4op06374" className="VgO9Yg"></div>
                </div>

                <div data-mesh-id="comp-m4op06374inlineContent-gridContainer" data-testid="mesh-container-content">
                 
                  <h3 className="font_3 wixui-rich-text__text" style={{ textAlign: "center", fontSize: "40px" }}>
                    The 7-Step Process
                  </h3>

                  <div className="M7AL1H comp-m4q5sn2m wixui-video-box">
                    <video 
                      id="comp-m4q5sn2m_video"
                      className="K8MSra"
                      playsInline
                      preload="auto"
                      loop
                      width="100%"
                      height="100%"
                      muted
                      controls
                    >
                      <source 
                        src="https://video.wixstatic.com/video/07cee9_0c3831de841f49519990acef33f8eb65/720p/mp4/file.mp4" 
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  <p className="font_8 wixui-rich-text__text" style={{ fontSize: "18px", fontWeight: "700", fontFamily: "Arial, 'MS PGothic', Dotum, Helvetica, sans-serif" }}>
                    TO DO: Add Content Here
                  </p>
                </div>
              </div>

          
              <div id="comp-m4op063a9" className="comp-m4op063a9 YzqVVZ wixui-column-strip__column">
                <h3 className="font_3 wixui-rich-text__text" style={{ textAlign: "center", fontSize: "40px" }}>
                  The Author
                </h3>

                <p className="font_8 wixui-rich-text__text" style={{ fontSize: "18px", fontFamily: "Arial, 'MS PGothic', Dotum, Helvetica, sans-serif" }}>
                  CMW
                </p>

         
                <div className="LjV9wd comp-m4op6qjz wixui-image">
                  <img 
                    src="https://static.wixstatic.com/media/07cee9_3ce148e3adb240fea1ac9c0557980ecf~mv2.png/v1/fill/w_484,h_445,al_c,lg_1,q_85,enc_avif,quality_auto/HG%20CYTW1.png"
                    alt="Howard TO DO: Add Content Here"
                    width="484"
                    height="445"
                    style={{ width: "100%", objectFit: "cover", objectPosition: "center" }}
                  />
                </div>

         
                <h6 className="font_6 wixui-rich-text__text" style={{ fontSize: "18px" }}>
                  Speaking Engagements
                </h6>
                
                <ul className="font_8 wixui-rich-text__text" style={{ fontSize: "15px", fontFamily: "Arial, 'MS PGothic', Dotum, Helvetica, sans-serif" }}>
                  <li>TO DO: Add Content Here</li>

                </ul>

                <a 
                  href="https://www.TO DO: Add Content Here.com/author-TO DO: Add Content Here"
                  className="StylableButton2545352419__root wixui-button"
                  aria-label="More about the Author"
                >
                  <span className="StylableButton2545352419__label wixui-button__label">
                    More about the Author
                  </span>
                </a>
              </div>
            </div>
          </section>

          */}
        </div>
        {/* Zone 4 - LinkedIn Posts */}
     
        <div className="zone zone-4">
          {/*
         <span style={{ fontSize: "2.0em", marginTop: "-1.5vh", lineHeight: "normal", textAlign:"center"}}>Leadership</span>
          <div className="o6oDlF" id="comp-m3kc6a031_wrapper" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "20px" }}>

         
            {[
              {
                id: "howard",
                name: "Howard TO DO: Add Content Here",
                title: "Principal",
                imgSrc: "https://static.wixstatic.com/media/07cee9_648de0b2307c4c7e8d2be3096eb620ef~mv2.png/v1/crop/x_187,y_0,w_624,h_702/fill/w_287,h_323,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/howard%2025.png",
                profileLink: "https://www.TO DO: Add Host.com/howardTO DO: Add Content Here",
                linkedin: "https://www.linkedin.com/in/TO DO: Add Content Here-38a81841/",
              },
              {
                id: "jacqueline",
                name: "Jacqueline TO DO: Add Content Here",
                title: "Chief Executive Officer",
                imgSrc: "https://static.wixstatic.com/media/07cee9_f5b69e20e29546339fcbb04e8c6b69fa~mv2.png/v1/fill/w_287,h_323,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/jackie25.png",
                profileLink: "https://www.TO DO: Add Host.com/jacquelineTO DO: Add Content Here",
                linkedin: "https://www.linkedin.com/in/jacqueline-TO DO: Add Content Here-877b055/",
              }
            ].map((person) => (
              <div key={person.id} className="comp-m3kc6a044 YzqVVZ wixui-repeater__item" role="listitem" style={{ flex: "1 1 45%", maxWidth: "45%" }}>
                <div id={`bgLayers_${person.id}`} data-hook="bgLayers" className="MW5IWV">
                  <div data-testid="colorUnderlay" className="LWbAav Kv1aVt"></div>
                </div>

                <div data-mesh-id={`comp-m3kc6a044__${person.id}inlineContent`} data-testid="inline-content">
                  <div data-mesh-id={`comp-m3kc6a044__${person.id}inlineContent-gridContainer`} data-testid="mesh-container-content">

                    
                    <div id={`comp-m3kc6a06__${person.id}`} className="LjV9wd comp-m3kc6a06 wixui-image">
                      <a href={person.profileLink} target="_self" rel="noopener noreferrer">
                        <img 
                          src={person.imgSrc} 
                          alt={person.name} 
                          width="287" 
                          height="323" 
                          style={{ width: "100%", height: "auto", objectFit: "cover" }} 
                        />
                      </a>
                    </div>

               
                    <div id={`comp-m5mlez6q1__${person.id}`} className="HcOXKn c9GqVL QxJLC3 lq2cno YQcXTT comp-m5mlez6q1 wixui-rich-text">
                      <p className="font_5 wixui-rich-text__text" style={{ fontSize: "20px", textAlign: "center" }}>
                        <a href={person.profileLink} target="_self" className="wixui-rich-text__text">
                          {person.name}
                        </a>
                      </p>
                    </div>

                    <div id={`comp-m5murxv0__${person.id}`} className="LjV9wd comp-m5murxv0 wixui-image" style={{ textAlign: "center" }}>
                      <a href={person.linkedin} target="_blank" rel="noopener noreferrer">
                        <img 
                          src="https://static.wixstatic.com/media/07cee9_6f267fa6492a48afb249f9a61665a66d~mv2.png/v1/fill/w_37,h_36,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/LinkedIn_icon_circle_edited.png" 
                          alt="LinkedIn Icon" 
                          width="37" 
                          height="36" 
                          style={{ width: "37px", height: "36px", objectFit: "cover" }} 
                        />
                      </a>
                    </div>

                  </div>
                </div>
              </div>
            ))}
          </div> 
          */}  
        </div>    
  

      </div>
      
    </div>
    </main>
  <Footer />
  </div>
  )
}

export default IndexHome
